import React, { useState } from 'react';
import { FAQS } from '../utils/faqSesaat';

/* ═══════════════════════════════════════════════════════════════
   FaqSection — FAQ accordion DIKONGSI (satu sumber, auto-sync)
   ───────────────────────────────────────────────────────────────
   Dipakai oleh:
     • PricingBaruView  (/pricing-baru)
     • SalesPageView    (/sesaat-1)
     • StartGate        (gate langganan)
   Edit soalan/jawapan di sini SEKALI → ketiga-tiga tempat ikut.

   Self-contained: guna Tailwind + Material Symbols (dah load global
   index.html). Kad putih + border cream — nampak elok atas cream/putih.

   Props:
     defaultOpen — index FAQ yang terbuka mula-mula (default 0). -1 = semua tutup.
   ═══════════════════════════════════════════════════════════════ */


export default function FaqSection({ defaultOpen = 0 }) {
    const [openFaq, setOpenFaq] = useState(defaultOpen);

    return (
        <section className="max-w-[760px] mx-auto px-7 py-16" style={{ fontFamily: "'Inter', sans-serif" }}>
            <div className="text-center mb-10">
                <div className="inline-flex items-center justify-center w-11 h-11 rounded-full bg-white border border-[#e6e3db] mb-4">
                    <span className="material-symbols-outlined text-[22px] text-[#5b53e8]" style={{ fontVariationSettings: "'FILL' 1" }}>quiz</span>
                </div>
                <h2 className="font-extrabold text-[#14130f]" style={{ fontSize: 'clamp(28px, 4vw, 40px)', letterSpacing: '-0.02em' }}>Soalan lazim</h2>
                <p className="mt-3 text-[#6b6a64]">Semua yang anda perlu tahu tentang produk &amp; pembayaran.</p>
            </div>
            <div className="space-y-3">
                {FAQS.map((f, i) => {
                    const open = openFaq === i;
                    return (
                        <div key={f.q} className="rounded-2xl border border-[#e6e3db] bg-white overflow-hidden">
                            <button
                                onClick={() => setOpenFaq(open ? -1 : i)}
                                className="w-full flex items-center gap-3.5 px-5 py-4 text-left"
                            >
                                <span className="inline-flex items-center justify-center w-9 h-9 rounded-lg bg-[#f4f3ef] text-[#5b53e8] shrink-0">
                                    <span className="material-symbols-outlined text-[18px]">{f.icon}</span>
                                </span>
                                <span className="flex-1 text-sm font-bold text-[#14130f]">{f.q}</span>
                                <span className={`material-symbols-outlined text-[20px] text-[#9c9a92] transition-transform ${open ? 'rotate-180' : ''}`}>expand_more</span>
                            </button>
                            {open && (
                                <div className="px-5 pb-5 pl-[70px] text-sm text-[#6b6a64] leading-relaxed">{f.a}</div>
                            )}
                        </div>
                    );
                })}
            </div>
        </section>
    );
}
